import http from '../../api/http'
import createStore from "../helper"

const store = createStore("departments");

const actions = {
  getBasic({ commit}, params ) {
    http.get(`/departments/basic`, { params }).then(({ data }) => {
      commit('SET_DATA', data['hydra:member'])
    })
  }
}

store.actions = { ...store.actions, ...actions }

export default store;